module.exports = __webpack_public_path__ + "static/media/netcore.ff14392e.png";